import { TextButton } from "@clipboard-health/ui-components";
import { CLIPBOARD_SCORE_FULL_PATH } from "@src/appV2/redesign/ClipboardScore/utils/paths";

export function ClipboardScoreLink() {
  return (
    <TextButton
      component="button"
      sx={(theme) => ({ textDecorationColor: theme.palette.text.primary })}
      LinkComponent="a"
      href={CLIPBOARD_SCORE_FULL_PATH}
    >
      Learn more
    </TextButton>
  );
}
